import { render, staticRenderFns } from "./TrainingRoomPage.vue?vue&type=template&id=76df320c&scoped=true"
import script from "./TrainingRoomPage.vue?vue&type=script&lang=ts"
export * from "./TrainingRoomPage.vue?vue&type=script&lang=ts"
import style0 from "./TrainingRoomPage.vue?vue&type=style&index=0&id=76df320c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df320c",
  null
  
)

export default component.exports